/** GCS/S3 object key prefix for user-private files (e.g. user67/2026/06/29/abc.jpg). */
const USER_FILE_KEY_PATTERN = /^user\d+\//;

/** GCS/S3 object key prefix for shared/public uploads (e.g. usersharedfiles/...). */
const SHARE_FILE_KEY_PREFIX = 'usersharedfiles/';

export function isFileKeyPath(value: unknown): value is string {
  if (!value || typeof value !== 'string') return false;
  if (value.startsWith('http://') || value.startsWith('https://')) return false;
  if (value.startsWith('data:')) return false;
  return USER_FILE_KEY_PATTERN.test(value) || value.startsWith(SHARE_FILE_KEY_PREFIX);
}

export function isShareFileKeyPath(value: string): boolean {
  return value.startsWith(SHARE_FILE_KEY_PREFIX);
}

/** Extract keyPath from stored image/file field value. */
export function getStoredFileKeyPath(
  value: string | { url?: string } | null | undefined
): string | null {
  if (!value) return null;
  if (typeof value === 'string') {
    return isFileKeyPath(value) ? value : null;
  }
  const url = value.url;
  return url && isFileKeyPath(url) ? url : null;
}
